import React from "react";

function profileCard(props) {
  const {
    name,
    avatar_url,
    bio,
    blog,
    email,
    followers,
    public_repos,
    html_url,
    location
  } = props.profile;

  return (
    <div className="row card-profile">
      <div className="col s12 ">
        <div className="card">
          <div className="card-image">
            <img src={avatar_url} alt="profile" />
            <span className="card-title poppins bold">{name}</span>
            <a
              href={html_url}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-floating halfway-fab waves-effect waves-light red"
            >
              <i className="material-icons">launch</i>
            </a>
          </div>
          <div className="card-content">
            <ul className="profile-links">
              {location ? (
                <li className="content-link">
                  <span>
                    <i className="material-icons">location_on</i>
                  </span>
                  {location}
                </li>
              ) : null}
              {email ? (
                <li className="content-link">
                  <span>
                    <i className="material-icons">email</i>
                  </span>
                  {email}
                </li>
              ) : null}
              {blog ? (
                <li>
                  <a
                    href={blog}
                    target="_blank"
                    className="content-link"
                    rel="noopener noreferrer"
                  >
                    <i className="material-icons">language</i>
                    {blog}
                  </a>
                </li>
              ) : null}
            </ul>

            <p>{bio}</p>
          </div>

          <div className="card-actions">
            <div className="row">
              <div className="col s6">
                <div className="icon-footer">
                  <div className="icon">
                    <i className="material-icons">class</i>
                  </div>
                  <div className="iconwithtext">
                    <span className="d-block">Repos</span>
                    <span>{public_repos}</span>
                  </div>
                </div>
              </div>
              <div className="col s6">
                <div className="icon-footer">
                  <div className="icon">
                    <i className="material-icons">favorite</i>
                  </div>
                  <div className="iconwithtext">
                    <span className="d-block">Followers</span>
                    <span>{followers}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default profileCard;
